export default "__VITE_ASSET__CvxG6Mvu__"